<div class="flex flex-col pt-3 items-center justify-between" *lohiFeatureFlag="'migrationMapDriverInfo'">
  <div class="flex">
    <ng-container *ngIf="finesAndFees$ | async as finesAndFees">
      <a
        [routerLink]="['../settlement', 'details', finesAndFees.lastSettlementId]"
        class="md:col-span-4 p-2 bg-red-500 font-semibold text-white mb-2"
        *ngIf="finesAndFees?.trailerFees?.chargeCount + finesAndFees?.shiftFees?.chargeCount > 0"
      >
        You have been penalized
        {{
          finesAndFees?.trailerFees?.totalCostInCents + finesAndFees?.shiftFees?.totalCostInCents | currencyInPennies
        }}
        on your most recent settlement for
        <ng-container *ngIf="finesAndFees?.trailerFees?.chargeCount">
          {{ finesAndFees?.trailerFees?.chargeCount }} Unreturned Trailers
        </ng-container>
        <ng-container *ngIf="finesAndFees?.shiftFees?.chargeCount">
          {{ finesAndFees?.shiftFees?.chargeCount }} Driver's Shifts Skipped
        </ng-container>
      </a>
    </ng-container>
  </div>

  <a
    class="mb-2 flex w-full cursor-pointer font-bold text-lg text-blue-500 text-lg justify-end mr-5"
    [routerLink]="['../../billing']"
  >
    <span>Billing Export</span>
    <span class="material-icons text-base ml-1">arrow_forward</span>
  </a>

  <div class="grid grid-cols-2 gap-2">
    <div class="flex flex-col gap-2 card-width">
      <div class="card-with-shadow bg-white">
        <div class="text-lg font-bold border-b border-gray-400">
          <div class="p-2">Driver Shift Information</div>
        </div>
        <div class="flex flex-col">
          <div class="p-2 w-full flex flex-col">
            <mat-form-field>
              <input
                matInput
                [matDatepicker]="picker"
                placeholder="Choose a date"
                (dateChange)="onDateSelect($event)"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-col">
          <div class="w-full px-2 bg-white transition-all duration-300 flex flex-col">
            <div>
              <mat-slide-toggle
                *lohiFeatureFlag="'showArchivedHitchShiftCalendar'"
                class="mb-3"
                [checked]="isShowArchivedCancelHitchAndShift$ | async"
                (change)="toggleArchiveHitchShift()"
              >
                Show archived or canceled hitches/shifts
              </mat-slide-toggle>
            </div>
            <!-- Possible All Regions dropdown, will add it if they want this -->
          </div>
          <div
            [ngClass]="{ 'w-full': isDetailsViewOpen, hidden: !isDetailsViewOpen }"
            class="p-2 bg-white transition-all duration-300 min-w-0 flex flex-col relative overflow-auto"
          >
            <div *ngIf="selectedDay" class="grid gap-y-3">
              <div>
                <p class="font-bold text-2xl">
                  {{ selectedDay.date | date: 'MMMM d, y' }}
                  <span class="text-gray-600">{{ selectedDay.date | date: 'EEEE' }}</span>
                </p>
                <hr class="h-0.5 mt-1 bg-gray-400 border-0.2 opacity-25" />
              </div>

              <ng-container *ngIf="selectedDay.events && selectedDay.events.length > 0">
                <div class="flex flex-row items-center gap-x-1">
                  <mat-icon (click)="toggleContentEvents()" class="text-gray-600">
                    {{ isOpenEventToggle ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                  </mat-icon>
                  <span class="text-lg font-bold">Bonus events</span>
                  <span
                    class="px-2 py-1 font-bold leading-none bg-orange-500 text-white text-sm mr-1 self-center rounded-full"
                  >
                    {{ selectedDay.events.length }}
                  </span>
                </div>

                <div *ngIf="isOpenEventToggle">
                  <span *ngFor="let event of selectedDay.events; trackBy: 'id' | trackByKey" class="grid gap-y-1">
                    <ng-container [ngSwitch]="event.eventType">
                      <ng-container *ngSwitchCase="'bonus'">
                        <ng-container [ngSwitch]="event.ordersPricingType">
                          <ng-container *ngSwitchCase="'flat_rate_cents'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }}
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'percent'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue * 100 | number }}%
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'per_ton'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Ton
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'per_mile_cents'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Mile
                                </p>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'deadhead'">
                        <ng-container [ngSwitch]="event.ordersPricingType">
                          <ng-container *ngSwitchCase="'flat_rate_cents'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }}
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'percent'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue * 100 }}%
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'per_ton'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Ton
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'per_mile_cents'">
                            <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                              <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.startsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.startsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                                <mat-icon class="text-4xl">arrow_forward</mat-icon>
                                <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                                  <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                    {{ event.endsAt | date: 'MMM' }}
                                  </div>
                                  <div class="p-2">
                                    <div class="text-3xl font-bold text-center pb-2">
                                      {{ event.endsAt | date: 'd' }}
                                    </div>
                                    <div class="text-sm text-center text-gray-700">
                                      {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 p-2 text-center flex-1">
                                <p class="font-bold">
                                  {{ event.name }}
                                  Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Mile
                                </p>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>

                      <!-- Driver Retention Event Type -->
                      <ng-container *ngSwitchCase="'driver_retention'">
                        <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                          <div class="flex flex-row items-center gap-x-2">
                            <!-- Start Date -->
                            <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                              <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                {{ event.startsAt | date: 'MMM' }}
                              </div>
                              <div class="p-2">
                                <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                                <div class="text-sm text-center text-gray-700">
                                  {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                </div>
                              </div>
                            </div>
                            <mat-icon class="text-4xl">arrow_forward</mat-icon>
                            <!-- End Date -->
                            <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                              <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                                {{ event.endsAt | date: 'MMM' }}
                              </div>
                              <div class="p-2">
                                <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                                <div class="text-sm text-center text-gray-700">
                                  {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="mt-2 p-2 text-center flex-1">
                            <p class="font-bold">{{ event.name }}</p>
                            <p class="text-gray-700">
                              Additional Bonus of {{ event.retentionsPricingValue | currencyInPennies }}
                            </p>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </span>
                </div>
              </ng-container>

              <ng-container *ngIf="getVisibleNoShowDrivers().length > 0 || hasNonArchivedHitch()">
                <div>
                  <p class="text-2xl font-bold text-red-500">No Shows</p>
                  <div
                    *ngFor="let noShowDriver of getVisibleNoShowDrivers(); index as i; trackBy: trackByKeyNoShowDriver"
                    class="flex flex-col gap-y-1"
                  >
                    <ng-container *ngIf="!noShowDriver.archivedAt || (isShowArchivedCancelHitchAndShift$ | async)">
                      <div class="flex flex-row flex-wrap gap-y-2">
                        <div class="w-1/3 flex flex-col">
                          <span class="font-bold text-lg">{{ noShowDriver.name }}</span>
                          <span class="text-gray-600">{{ noShowDriver.regionName }}</span>
                        </div>
                        <div class="w-2/3">
                          <div class="flex flex-col">
                            <div
                              [ngClass]="getContainerClass(noShowDriver)"
                              class="font-bold w-full p-1 rounded-lg flex items-center justify-center gap-1 mb-1"
                            >
                              <mat-icon>{{ getMainIcon(noShowDriver) }}</mat-icon>
                              <span>{{ noShowDriver.startDateTimezone | date: 'M/d' }}</span>
                              <mat-icon>arrow_forward</mat-icon>
                              <span>{{ noShowDriver.lastDateTimezone | date: 'M/d' }}</span>
                              <mat-icon>alternate_email</mat-icon>
                              <span>
                                {{
                                  noShowDriver.startDateTimezone
                                    | date: 'yyyy-MM-ddTHH:mm:ssZ'
                                    | addMinutes: noShowDriver.shiftStartMinute
                                    | timeInTimezone: noShowDriver.regionTimezone
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Divider between drivers -->
                      <ng-container *ngIf="i < getVisibleNoShowDrivers().length - 1">
                        <hr class="h-0.5 my-1 bg-gray-400 border-0.2 opacity-25" />
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="getVisibleExcusedDrivers().length > 0 || hasNonArchivedHitch()">
                <div>
                  <p class="text-2xl font-bold text-red-500">Excused</p>
                  <div
                    *ngFor="
                      let excusedDriver of getVisibleExcusedDrivers();
                      index as i;
                      trackBy: trackByKeyExcusedDriver
                    "
                    class="flex flex-col gap-y-1"
                  >
                    <ng-container *ngIf="!excusedDriver.archivedAt || (isShowArchivedCancelHitchAndShift$ | async)">
                      <div class="flex flex-row flex-wrap gap-y-2">
                        <div class="w-1/3 flex flex-col">
                          <span class="font-bold text-lg">{{ excusedDriver.name }}</span>
                          <span class="text-gray-600">{{ excusedDriver.regionName }}</span>
                        </div>
                        <div class="w-2/3">
                          <div class="flex flex-col">
                            <div
                              [ngClass]="getContainerClass(excusedDriver)"
                              class="font-bold w-full p-1 rounded-lg flex items-center justify-center gap-1 mb-1"
                            >
                              <mat-icon>{{ getMainIcon(excusedDriver) }}</mat-icon>
                              <span>{{ excusedDriver.startDateTimezone | date: 'M/d' }}</span>
                              <mat-icon>arrow_forward</mat-icon>
                              <span>{{ excusedDriver.lastDateTimezone | date: 'M/d' }}</span>
                              <mat-icon>alternate_email</mat-icon>
                              <span>
                                {{
                                  excusedDriver.startDateTimezone
                                    | date: 'yyyy-MM-ddTHH:mm:ssZ'
                                    | addMinutes: excusedDriver.shiftStartMinute
                                    | timeInTimezone: excusedDriver.regionTimezone
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Divider between drivers -->
                      <ng-container *ngIf="i < getVisibleExcusedDrivers().length - 1">
                        <hr class="h-0.5 my-1 bg-gray-400 border-0.2 opacity-25" />
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="hitchesSelectedDay && hitchesSelectedDay.length > 0">
                <div class="mb-3">
                  <p class="text-2xl font-bold">Driver Hitches & Regions</p>
                  <div
                    *ngFor="let hitch of hitchesSelectedDay; index as i; trackBy: trackByKeyHitch"
                    class="flex flex-col"
                  >
                    <div class="flex flex-row flex-wrap gap-y-2">
                      <div class="w-1/3 flex flex-col" [ngClass]="hitch.archivedAt ? 'opacity-25' : ''">
                        <span class="font-bold text-lg">{{ hitch.driverName }}</span>
                        <span class="text-gray-600">{{ hitch.regionName }}</span>
                      </div>
                      <div class="w-2/3">
                        <div class="flex flex-col">
                          <ng-container *ngIf="hitch.startDateTimezone || hitch.lastDateTimezone">
                            <div
                              [ngClass]="getContainerClass(hitch)"
                              class="font-bold w-full p-1 rounded-lg flex items-center justify-center gap-1"
                            >
                              <mat-icon>{{ getMainIcon(hitch) }}</mat-icon>
                              <span>{{ hitch.startDateTimezone | date: 'M/d' }}</span>
                              <mat-icon>arrow_forward</mat-icon>
                              <span>{{ hitch.lastDateTimezone | date: 'M/d' }}</span>
                              <mat-icon>alternate_email</mat-icon>
                              <span>
                                {{
                                  hitch.startDateTimezone
                                    | date: 'yyyy-MM-ddTHH:mm:ssZ'
                                    | addMinutes: hitch.shiftStartMinute
                                    | timeInTimezone: hitch.regionTimezone
                                }}
                              </span>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <ng-container *ngFor="let shift of hitch.driverShifts; index as i; trackBy: trackByKeyHitch">
                      <div
                        class="w-full p-1 rounded-lg flex justify-between items-center my-1 bg-green-400 text-white"
                        [ngClass]="hitch.archivedAt ? 'opacity-25' : ''"
                      >
                        <span class="font-bold">On Shift</span>
                        <span>
                          {{ shift.startsAt | timeInTimezone: hitch.regionTimezone }}
                          -
                          {{ shift.endsAt | timeInTimezone: hitch.regionTimezone }}
                        </span>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="i < hitchesSelectedDay.length - 1">
                      <hr class="h-0.5 my-1 bg-gray-400 border-0.2 opacity-25" />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="selectedDay.hitchesFullDay.length < 1">
                <div class="flex flex-col items-center">
                  <img class="h-10 mb-3" src="/assets/images/user-dash.svg" alt="user dash" />
                  <p class="font-bold text-xl text-center">There are no drivers on hitch for the selected day</p>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <div class="card-with-shadow bg-white card-width">
        <div class="flex border-b border-gray-400 justify-between">
          <div class="flex flex-row">
            <div class="text-lg font-bold p-2">Alerts</div>
          </div>
          <div class="flex flex-col">
            <div class="flex flex-row justify-between items-center">
              <div class="hidden">
                <ng-container *ngIf="(clearingAllAlerts$$ | async) === false; else clearingAllAlerts">
                  <div
                    class="flex items-center rounded-full bg-gray-300 text-gray-600 px-1 cursor-pointer"
                    (click)="clearAll()"
                  >
                    <span class="material-icons text-base">clear</span>
                    <span class="text-sm">Clear All</span>
                  </div>
                </ng-container>
                <ng-template #clearingAllAlerts>
                  <mat-spinner diameter="16"></mat-spinner>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col overflow-y-auto h-full">
          <ng-container *ngIf="alerts$ | async as alerts">
            <ng-container *ngIf="alerts && alerts.length > 0; else noAlerts">
              <ng-container *ngFor="let alert of alerts; trackBy: 'id' | trackByKey">
                <ng-container [ngSwitch]="alert.type">
                  <div class="flex flex-row p-2 border-b border-gray-300 gap-x-1" *ngSwitchCase="'account'">
                    <img class="self-start mt-2" src="assets/images/notification.svg" />
                    <div class="flex flex-col flex-1">
                      <span class="text-sm text-gray-600 leading-normal">ACCOUNTING</span>
                      <a class="cursor-pointer" [routerLink]="['../../loads/list/completed']">
                        You have <span class="text-blue-500">{{ alert.description.replace('You have', '') }}</span>
                      </a>
                    </div>
                    <span
                      class="material-icons text-gray-600 text-lg mt-2 cursor-pointer"
                      (click)="dismissNotificationLocally(alert.id)"
                      >clear</span
                    >
                  </div>
                  <div class="flex flex-row p-2 border-b border-gray-300 gap-x-1" *ngSwitchCase="'driver_performance'">
                    <img class="self-start mt-2" src="assets/images/notification.svg" />
                    <div class="flex flex-col flex-1">
                      <details>
                        <summary>
                          <span class="text-sm text-gray-600 leading-normal">DRIVER PERFORMANCE</span>
                          <div class="cursor-pointer">
                            <span class="text-blue-500"
                              >{{ alert.description.replace('did not show up for their hitch', '') }} </span
                            >did not show up for their hitch
                          </div>
                          <span class="text-gray-600 text-sm">{{ alert.createdAt | ago }}</span>
                        </summary>
                        <div class="mt-1 flex flex-col">
                          <div
                            class="flex flex-row text-sm justify-between"
                            *ngFor="let user of alert.noShowUsers; trackBy: 'name' | trackByKey"
                          >
                            <span class="text-gray-600 cursor-pointer" (click)="redirectToDriverScorecard(user.id)">{{
                              user.name
                            }}</span>
                            <span class="text-blue-500">{{ user.phone | phone }}</span>
                          </div>
                        </div>
                      </details>
                    </div>
                    <span
                      class="material-icons text-gray-600 text-lg mt-2 cursor-pointer"
                      *ngIf="!alert.dismissing; else dismissing"
                      (click)="alert.dismissing = true; dismissNotification([alert.id])"
                      >clear</span
                    >
                    <ng-template #dismissing>
                      <span class="mt-2">
                        <mat-spinner diameter="16" [color]="'primary'"></mat-spinner>
                      </span>
                    </ng-template>
                  </div>
                  <ng-container *lohiFeatureFlag="'penaltyAlerts'">
                    <div class="flex flex-row p-2 border-b border-gray-300 gap-x-1" *ngSwitchCase="'penalties'">
                      <img class="self-start mt-2" src="assets/images/penalties.svg" />
                      <div class="flex flex-col flex-1">
                        <details>
                          <summary>
                            <span class="text-sm text-gray-600 leading-normal">PENALTIES</span>
                            <div class="cursor-pointer">
                              <span class="text-blue-500">{{ getPenaltyAlertTitleTrailerNumber(alert.title) }}</span>
                              {{ getPenaltyAlertTitle(alert.title) }}
                            </div>
                            <span class="text-gray-600 text-sm">{{ alert.createdAt | ago }}</span>
                          </summary>
                          <div class="mt-1 flex flex-col">
                            <div>
                              <span class="text-gray-600">
                                {{ getPenaltyAlertDescription(alert.description) }}
                              </span>
                              <span class="text-blue-500 cursor-pointer"
                                >{{ getPenaltyAlertDescriptionDriverNumber(alert.description) }}
                              </span>
                            </div>
                          </div>
                        </details>
                      </div>
                      <span
                        class="material-icons text-gray-600 text-lg mt-2 cursor-pointer"
                        *ngIf="!alert.dismissing; else dismissing"
                        (click)="alert.dismissing = true; dismissNotification([alert.id])"
                        >clear</span
                      >
                      <ng-template #dismissing>
                        <span class="mt-2">
                          <mat-spinner diameter="16" [color]="'primary'"></mat-spinner>
                        </span>
                      </ng-template>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #noAlerts>
              <div class="flex flex-col items-center h-full justify-center">
                <img class="mb-3 h-16" src="assets/images/no-alerts.svg" />
                <span class="mb-1 text-gray-900 text-lg">No Alerts!</span>
                <span class="text-gray-600 text-xs">Check back later for new alerts</span>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>

      <div class="card-with-shadow bg-white">
        <ng-container *ngIf="driversHitchStats$ | async as driversHitchStats">
          <div class="flex border-b border-gray-400 justify-between">
            <div class="text-lg font-bold p-2">Now ({{ driversHitchStats.drivers }} Drivers)</div>
            <a
              class="flex flex-row text-blue-500 items-center justify-between cursor-pointer p-2 gap-1"
              [routerLink]="['../calendar']"
            >
              <span>View Driver Calendar</span>
              <span class="material-icons text-base mr-1">arrow_forward</span>
            </a>
          </div>

          <div class="flex flex-row gap-5 p-2">
            <div
              class="card-with-shadow-4px-radius bg-white border border-gray-400 w-1/2 p-2 grid grid-cols-1 justify-between"
            >
              <div class="flex flex-col">
                <div class="text-gray-500">On Hitch</div>
                <div class="text-4xl font-bold mt-1">{{ driversHitchStats.onHitch }}</div>
              </div>
              <div class="flex flex-row w-full justify-between items-end text-gray-600">
                <div class="font-medium">Excused Absences</div>
                <div class="font-bold">{{ driversHitchStats.noShows }}</div>
              </div>
            </div>

            <div class="card-with-shadow-4px-radius bg-white border border-gray-400 w-1/2 p-2 grid grid-cols-1 gap-5">
              <div class="flex flex-col">
                <div class="text-gray-500">Off Hitch</div>
                <div class="text-4xl font-bold mt-1">
                  {{ driversHitchStats.offHitch }}
                </div>
              </div>
              <div class="flex flex-col items-end">
                <div class="flex flex-row w-full justify-between text-orange-500">
                  <div class="font-medium">No Hitch Booked</div>
                  <div class="font-bold">{{ driversHitchStats.doesNotHaveFutureHitch }}</div>
                </div>
                <div class="flex flex-row w-full justify-between text-gray-600">
                  <div class="font-medium">On Hitch Later</div>
                  <div class="font-bold">{{ driversHitchStats.hasFutureHitch }}</div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="card-with-shadow bg-white">
        <mat-tab-group>
          <mat-tab label="Tiers">
            <div class="flex flex-col border-t-2 border-gray-400">
              <div
                class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto h-35 md:h-75 divide-y divide-gray-400"
              >
                <mat-slide-toggle
                  class="m-2"
                  [checked]="(tierDropsEnabled$ | async)?.enabled"
                  (change)="toggleTierNotification()"
                >
                  Toggle Driver Tier Notifications
                </mat-slide-toggle>
                <ng-container *ngIf="tierFeeds$ | async as tierFeedsDate">
                  <div class="flex-row flex py-3 px-2 justify-between">
                    <div
                      class="flex flex-col gap-y-1 items-center"
                      *ngFor="let tier of tierFeedsDate.tierDiverCount; trackBy: 'id' | trackByKey"
                    >
                      <span class="font-semibold text-xs text-gray-500">{{ tier.numberOfDrivers }}</span>
                      <img src="{{ getTierImage(tier.tierId) }}" class="w-3" />
                      <span class="font-bold" [style]="{ color: getTierColor(tier.tierId) }">
                        {{ tier.driverTakeRate }} %
                      </span>
                    </div>
                  </div>
                  <div class="flex flex-col">
                    <div *ngFor="let feed of tierFeedsDate.driverTierFeeds; trackBy: 'id' | trackByKey">
                      <ng-container *ngIf="feed.isDemoted; else normalFeed">
                        <div
                          class="flex flex-col border-t border-gray-300 p-2"
                          style="background: rgba(240, 79, 15, 0.07)"
                        >
                          <div class="flex justify-between">
                            <div class="text-gray-900">
                              <a
                                class="font-bold cursor-pointer"
                                [routerLink]="['../../drivers', feed.userId, 'profile']"
                                >{{ feed.username }}</a
                              >
                              got demoted for {{ feed.shortReason }}
                            </div>
                            <div>
                              <span class="text-xs px-2 py-1 bg-blue-300 rounded-md text-right whitespace-nowrap"
                                >{{ feed.points | number }} pts</span
                              >
                            </div>
                          </div>
                          <span class="text-xs text-gray-600">{{ feed.createdAt | ago }}</span>
                        </div>
                      </ng-container>
                      <ng-template #normalFeed>
                        <div class="flex flex-col border-t border-gray-300 p-2">
                          <div class="flex justify-between">
                            <div class="text-gray-900">
                              <a
                                class="font-bold cursor-pointer"
                                [routerLink]="['../../drivers', feed.userId, 'profile']"
                                >{{ feed.username }}</a
                              >
                              reached {{ feed.currentTierName }} Tier
                            </div>
                            <div>
                              <span class="text-xs px-2 py-1 bg-blue-300 rounded-md text-right whitespace-nowrap"
                                >{{ feed.points | number }} pts</span
                              >
                            </div>
                          </div>
                          <span class="text-xs text-gray-600">{{ feed.createdAt | ago }}</span>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Tier Events">
            <div class="flex flex-col border-t-2 border-gray-400">
              <div
                class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto h-35 md:h-75 divide-y divide-gray-400"
              >
                <mat-form-field class="px-3 pt-3">
                  <mat-select placeholder="Select Driver" (valueChange)="selectDriverTier($event)">
                    <mat-option>
                      <ngx-mat-select-search
                        placeholderLabel="Search"
                        noEntriesFoundLabel="No driver found"
                        [formControl]="tierDriverSearchText"
                      ></ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                      *ngFor="let tierDriver of filteredTierDrivers$$ | async; trackBy: 'userID' | trackByKey"
                      [value]="tierDriver.userID"
                    >
                      <span>{{ tierDriver.userName }} ({{ tierDriver.userPhone }})</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-container *ngFor="let tierEvent of tierEvents$ | async; trackBy: 'id' | trackByKey">
                  <div class="flex flex-col">
                    <div class="flex flex-col border-t border-gray-300 p-2">
                      <div class="flex justify-between">
                        <div class="text-gray-900">
                          {{ tierEvent.name }}
                        </div>
                        <div>
                          <span
                            class="text-xs px-2 py-1 rounded-md text-right whitespace-nowrap"
                            [ngClass]="tierEvent.points >= 0 ? 'bg-green-100' : 'bg-red-200'"
                            *ngIf="tierEvent.points != 0"
                            >{{ tierEvent.points | number }} pts</span
                          >
                          <span
                            class="text-xs px-2 py-1 rounded-md border-2 text-right whitespace-nowrap"
                            *ngIf="tierEvent.points === 0"
                            >{{ tierEvent.points | number }} pts</span
                          >
                        </div>
                      </div>
                      <span class="text-xs text-gray-600">{{ tierEvent.createdAt | ago }}</span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div class="card-with-shadow flex flex-row justify-between bg-gray-700 rounded text-white p-2">
        <div class="flex flex-col gap-1">
          <span class="text-2xl font-bold">Feedback</span>
          <span class="text-sm">Help us improve 5F. We want to provide you with the best experience possible.</span>
        </div>
        <div class="flex items-center">
          <a
            class="cursor-pointer text-gray-700 items-center mat-raised-button"
            target="_blank"
            href="https://5ff.typeform.com/to/IpMr68LL"
          >
            Provide Feedback
          </a>
        </div>
      </div>
    </div>
  </div>

  <ng-template #crewModal>
    <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
      <div mat-dialog-title>Crews in {{ selectedFracActivity.regionName }}</div>
      <ng-container *lohiFeatureFlag="'qualifiedDriversActivityReport'; else allActivityReportInfo">
        <ng-container *ngIf="fracsActivityWithQualifiedInfo$ | async as fracActivityReportPerRegionWithQualifiedInfo">
          <div mat-dialog-content>
            <div class="text-lg font-semibold mb-3">Fracs that your drivers are qualified for</div>
            <lohi-frac-activity-info
              class="flex-1"
              [fracStatus]="'running'"
              [title]="'Fracs Running Today'"
              [fracActivityInfo]="
                getActivityReportByRegionId(
                  fracActivityReportPerRegionWithQualifiedInfo.qualifiedFracs,
                  selectedFracActivity.regionId
                )?.fracsRunningToday
              "
            ></lohi-frac-activity-info>

            <lohi-frac-activity-info
              class="flex-1"
              [fracStatus]="'down'"
              [title]="'Fracs Down'"
              [fracActivityInfo]="
                getActivityReportByRegionId(
                  fracActivityReportPerRegionWithQualifiedInfo.qualifiedFracs,
                  selectedFracActivity.regionId
                )?.fracsDown
              "
            ></lohi-frac-activity-info>

            <lohi-frac-activity-info
              class="flex-1"
              [fracStatus]="'soon'"
              [title]="'Frac Starting Soon'"
              [fracActivityInfo]="
                getActivityReportByRegionId(
                  fracActivityReportPerRegionWithQualifiedInfo.qualifiedFracs,
                  selectedFracActivity.regionId
                )?.fracsStartingSoon
              "
            ></lohi-frac-activity-info>

            <div class="text-lg font-semibold mt-3">Fracs that your drivers are not qualified for</div>
            <div class="text-gray-700 my-3">
              Your drivers don't have experience with the trailers required for these sites
            </div>
            <lohi-frac-activity-info
              class="flex-1"
              [fracStatus]="'running'"
              [title]="'Fracs Running Today'"
              [fracActivityInfo]="
                getActivityReportByRegionId(
                  fracActivityReportPerRegionWithQualifiedInfo.nonQualifiedFracs,
                  selectedFracActivity.regionId
                )?.fracsRunningToday
              "
            ></lohi-frac-activity-info>

            <lohi-frac-activity-info
              class="flex-1"
              [fracStatus]="'down'"
              [title]="'Fracs Down'"
              [fracActivityInfo]="
                getActivityReportByRegionId(
                  fracActivityReportPerRegionWithQualifiedInfo.nonQualifiedFracs,
                  selectedFracActivity.regionId
                )?.fracsDown
              "
            ></lohi-frac-activity-info>

            <lohi-frac-activity-info
              class="flex-1"
              [fracStatus]="'soon'"
              [title]="'Frac Starting Soon'"
              [fracActivityInfo]="
                getActivityReportByRegionId(
                  fracActivityReportPerRegionWithQualifiedInfo.nonQualifiedFracs,
                  selectedFracActivity.regionId
                )?.fracsStartingSoon
              "
            ></lohi-frac-activity-info>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #allActivityReportInfo>
        <div mat-dialog-content>
          <lohi-frac-activity-info
            class="flex-1"
            [fracStatus]="'running'"
            [title]="'Fracs Running Today'"
            [fracActivityInfo]="selectedFracActivity.fracsRunningToday"
          ></lohi-frac-activity-info>

          <lohi-frac-activity-info
            class="flex-1"
            [fracStatus]="'down'"
            [title]="'Fracs Down'"
            [fracActivityInfo]="selectedFracActivity.fracsDown"
          ></lohi-frac-activity-info>

          <lohi-frac-activity-info
            class="flex-1"
            [fracStatus]="'soon'"
            [title]="'Frac Starting Soon'"
            [fracActivityInfo]="selectedFracActivity.fracsStartingSoon"
          ></lohi-frac-activity-info>
        </div>
      </ng-template>
    </ng-container>
  </ng-template>
</div>
